import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  capitalizeFirst,
  DB_POSTFIX,
  IMG_MENU_BAR,
  upperCase,
} from "../../utils";
import RightSidebar from "../rightSidebar";
import { CssBaseline, Drawer, useMediaQuery } from "@mui/material";

import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import MenuIcon from "@mui/icons-material/Menu";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import RightSideDrawer from "../rightSidebar/rightSideDrawer";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import NotificationCountBadge from "./notificationCountBadge";

const Header = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [notificationCount, setNotificationCount] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);

  const theme = useTheme();
  const isXL = useMediaQuery(theme.breakpoints.up("xl")); // XL screens
  const isSmall = useMediaQuery(theme.breakpoints.down("sm")); // Small screens

  useEffect(() => {
    /*window.onscroll = function () {
      myFunction();
    };

    // Get the navbar
    var navbar = document.getElementById("ps__top__menu");

    // Get the offset position of the navbar
    var sticky = 240; //navbar.offsetTop;

    // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
      if (window.pageYOffset >= sticky) {
        navbar.classList.add("darkHeader");
      } else {
        navbar.classList.remove("darkHeader");
      }
    }*/
  }, []);

  const backButtonClick = () => {
    if (props.onBack) props.onBack();
    else navigate("/staff/app");
  };

  const getBackButton = () => {
    if (props.noBack) return <div className="back-button me-2 me-2"></div>;
    return props.backAction ? (
      <div className="back-button me-2 me-2">
        <a onClick={(e) => backButtonClick()}>
          <i className="fa-solid fa-arrow-left-long"></i>
          {/*<i className="fa-solid fa-chevron-left"></i>*/}
        </a>
      </div>
    ) : (
      <>
        <div class="logo-wrapper">
          <span className="brand-logo-text">
            {props.title || context.settingValue("college_app_short_name")}
          </span>
        </div>
      </>
    );
  };
  const linkClick = (toUrl) => {
    navigate(toUrl);
  };
  /*  const loadData = () => {
    const form = new FormData();
    form.append("type", "staff");
    form.append("uuid", context.user.uuid);
    form.append("course", context.user.emp_academic_department);
    axios.post(ServiceUrl.MOB.MY_NOTIFICATION_COUNT, form).then((res) => {
      if (res["data"].status == "1") {
        if (parseInt(res["data"].data.history_count) > 0) {
          setNotificationCount(
            parseInt(res["data"].data.count) -
              parseInt(res["data"].data.history_count)
          );
        } else {
          setNotificationCount(parseInt(res["data"].data.count));
        }
      } else {
      }
      //  setLoader(false);
    });
  }; */

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed">
          <Toolbar>
            {!props.noBack && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
                onClick={(e) => backButtonClick()}
              >
                <KeyboardBackspaceIcon />
              </IconButton>
            )}

            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              {props.title ||
                upperCase(context.settingValue("billheader_name"))}
            </Typography>
            {/*<IconButton
              size="large"
              aria-label="notification"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
            >
              <NotificationsIcon />
            </IconButton>*/}

            {!props.rightActions && (
              <>
                <NotificationCountBadge />
                <IconButton
                  size="large"
                  aria-label="menu"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={(e) => setShowSidebar(!showSidebar)}
                >
                  <MenuIcon />
                </IconButton>
              </>
            )}
            {props.rightActions || ""}
          </Toolbar>
        </AppBar>
      </Box>

      <RightSideDrawer
        visible={showSidebar}
        onHide={(e) => setShowSidebar(false)}
        {...props}
      />
    </>
  );

  return (
    <>
      <div className="header-area shadow" id="headerArea">
        <div
          className="container h-100 d-flex align-items-center justify-content-between d-flex rtl-flex-d-row-r "
          data-aos="zoom-in"
        >
          {getBackButton()}
          <div className="page-heading">
            {!props.hideLogoText && (
              <>
                {upperCase(context.settingValue("billheader_name")) &&
                props.title &&
                !props.title.includes("Select Your College") ? (
                  <>
                    <h6 className="mb-0 mobf-size">
                      {upperCase(context.settingValue("billheader_name"))}{" "}
                      <br />
                    </h6>
                    <span
                      style={{
                        textAlign: "center",
                        display: "block",
                        fontWeight: " 500",
                      }}
                    >
                      {props.title}
                    </span>
                  </>
                ) : props.title ? (
                  <>
                    <h6 className="mb-0 mobf-size">
                      <h4>{capitalizeFirst(DB_POSTFIX)} Institutions</h4>
                      <span style={{ marginLeft: "10%" }}>
                        {" "}
                        Select Your College
                      </span>
                    </h6>
                  </>
                ) : (
                  <h6 className="mb-0 mobf-size">
                    {upperCase(context.settingValue("billheader_name"))} <br />
                  </h6>
                )}
              </>
            )}

            {props.hideLogoText && props.title}
          </div>
          <div className="navbar-logo-container d-flex align-items-center">
            <div className="header-option">
              <ul>
                {props.rightActions ? (
                  props.rightActions
                ) : (
                  <li
                    className="cursor-pointer"
                    onClick={(e) => setShowSidebar(!showSidebar)}
                  >
                    <img
                      src={IMG_MENU_BAR.default}
                      className="img-fluid"
                      alt=""
                      style={{ marginTop: "-8px" }}
                    />
                    {/*<Link to="/staff/app/myprofile">
                    <i className="fa-solid fa-user"></i>
                  </Link>*/}
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <RightSidebar
        visible={showSidebar}
        onHide={(e) => setShowSidebar(false)}
        {...props}
      />
    </>
  );
};
export default Header;
